<template>
  <div>
    <left-menu-admin menuActive="0" :sessionData="session"></left-menu-admin>
    <v-main>
      <div class="col-md-12 ml-sm-auto col-lg-12 px-4">
        <v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs>
        <v-row>
                    <v-dialog v-model="dialogView" persistent max-width="60%">
            <v-card>
              <v-toolbar
                dark
                color="primary"
              >
                <v-btn
                  icon
                  dark
                  @click="dialogView = false"
                >
                  <v-icon>mdi-close</v-icon>
                </v-btn>
                <v-toolbar-title>ข้อมูลพนักงาน {{groupName}}</v-toolbar-title>
              </v-toolbar>
              <v-card-title>
                <v-text-field
                  v-model="search2"
                  append-icon="mdi-magnify"
                  label="Search"
                  single-line
                  hide-details
                ></v-text-field>
              </v-card-title>
              <v-card-text>
                <v-container>
                  <v-data-table
                  :headers="columnsEmp"
                  :items="dataItemEmp"
                  :search="search2"
                  :items-per-page="10"
                >
                </v-data-table>
                </v-container>
              </v-card-text>
               <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  elevation="2"
                  x-large
                  color="dark darken-1"
                  text
                  @click="dialogView = false"
                >
                  <v-icon left> mdi-cancel</v-icon>
                  ปิด
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <!-- edit -->
          <v-dialog v-model="dialogEdit" persistent max-width="80%">
            <v-card>
              <v-card-title>
                <span class="headline">แก้ไขข้อมูลกลุ่ม</span>
              </v-card-title>
              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col cols="6">
                      <v-row>
                        <v-col cols="12">
                          <v-text-field
                            label="menuCode*"
                            v-model="formUpdate.menuCode"
                            :rules="nameRules"
                            :counter="50"
                            maxlength="50"
                            required
                            readonly
                            dense
                            disable
                            outlined
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12">
                          <v-text-field
                            label="orderNumber*"
                            v-model="formUpdate.orderNumber"
                            :rules="nameRules"
                            :counter="50"
                            maxlength="50"
                            required
                            dense
                            disable
                            readonly
                            outlined
                          ></v-text-field>
                        </v-col>
                        <v-col cols="6">
                          <v-text-field
                            label="menuName*"
                            v-model="formUpdate.menuName"
                            readonly
                            :counter="50"
                            maxlength="50"
                            required
                            dense
                            disable
                            outlined
                          ></v-text-field>
                        </v-col>
                        <v-col cols="6">
                          <v-select
                            v-model="formUpdate.menuRefCodeHeader"
                            :items="MenuHeader"
                            dense
                            disable
                            readonly
                            outlined
                            label="Header Menu"
                          ></v-select>
                        </v-col>
                        <v-col cols="6">
                          <v-text-field
                            label="menuPath"
                            v-model="formUpdate.menuPath"
                            :counter="50"
                            maxlength="50"
                            dense
                            disable
                            readonly
                            outlined
                            required
                          ></v-text-field>
                        </v-col>
                        <v-col cols="6">
                          <v-select
                            v-model="formUpdate.menuType"
                            :items="menuType"
                            dense
                            disable
                            readonly
                            outlined
                            label="ประเภทเมนู"
                          ></v-select>
                        </v-col>
                        <v-col cols="6">
                          <v-select
                            v-model="formUpdate.masApplicationName"
                              :items="Application"
                            label="ระบบที่ใช้งาน"
                            dense
                            disable
                            readonly
                            outlined
                          ></v-select>
                        </v-col>
                      </v-row>
                    </v-col>
                    <v-col cols="6">
                      <v-row>
                        <v-data-table
                          v-model="formUpdate.userTypeGroupConvert"
                          :headers="headers"
                          :items="UserTypeGroup"
                          item-key="name"
                          item-value="name"
                          show-select
                          class="elevation-1"
                        >
                        <template v-slot:[`item.action`]="{ item }">
                          <v-btn
                            color="question"
                            fab
                            small
                            @click.stop="(dialogView = true), getDataEmployee(item)"
                          >
                            <v-icon dark> mdi-account </v-icon>
                          </v-btn>
                        </template>
                        </v-data-table>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  elevation="2"
                  x-large
                  color="blue darken-1"
                  text
                  @click="dialogEdit = false"
                >
                  <v-icon left> mdi-cancel</v-icon>
                  ปิด
                </v-btn>
                <v-btn
                  elevation="2"
                  x-large
                  color="success"
                  text
                  @click="editData()"
                >
                  <v-icon left>mdi-checkbox-marked-circle</v-icon>
                  แก้ไข
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <!-- end edit -->

          <!-- data table -->
          <v-col cols="12">
            <v-card elevation="7" v-if="dataReady">
              <v-card-title>
                <v-text-field
                  v-model="searchAll2"
                  append-icon="mdi-magnify"
                  label="Search"
                  single-line
                  hide-details
                ></v-text-field>
              </v-card-title>
              <v-card-text>
                <v-data-table
                  :headers="columns"
                  :items="dataItem"
                  :search="searchAll2"
                  :items-per-page="-1"
                >
                  <template v-slot:[`item.CREATE_DATE`]="{ item }">
                    {{ format_date(item.CREATE_DATE) }}
                  </template>
                  <template v-slot:[`item.LAST_DATE`]="{ item }">
                    {{ format_date(item.LAST_DATE) }}
                  </template>
                  <template v-slot:[`item.action`]="{ item }">
                    <v-btn
                      color="question"
                      fab
                      small
                      @click.stop="getDataById(item)"
                    >
                      <v-icon dark> mdi-tools </v-icon>
                    </v-btn>
                  </template>
                </v-data-table>
              </v-card-text>
            </v-card>
            <div v-if="!dataReady" class="text-center">
              <v-progress-circular
                indeterminate
                color="primary"
              ></v-progress-circular>
            </div>
          </v-col>
          <!-- end data table -->
        </v-row>
      </div>
    </v-main>
  </div>
</template>
<script>
import axios from 'axios' // api
import adminLeftMenu from '../../Sidebar.vue' // เมนู
// import moment from 'moment' // แปลง date

export default {
  components: {
    'left-menu-admin': adminLeftMenu
  },
  data () {
    return {
      PK: '',
      path: '/system_menu/', // Path Model
      // Menu Config
      breadcrumbs: [
        {
          text: 'Home',
          disabled: false,
          href: '/Core/Home'
        },
        {
          text: 'จัดการเมนู',
          disabled: true,
          href: 'HRM/System/Menu'
        }
      ],
      // End Menu Config
      dataReady: true,
      dateTime: '', // Generate DateTime
      date: new Date().toISOString().substr(0, 10),
      menu: false,
      menu2: false,
      menu3: false,
      menu4: false,
      code: 'SYS_MENU_', // Generate Code
      // Dialog Config ADD EDIT DELETE IMPORT
      dialogAdd: false,
      dialogEdit: false,
      dialogDelete: false,
      dialogImport: false,
      dialogView: false,
      // END Dialog Config ADD EDIT DELETE
      panel: [0],
      panel1: [1],
      session: this.$session.getAll(),
      // Search All
      searchAll: '',
      searchAll2: '',
      search2: '',
      // Search Advanced
      search: {
        menuCode: '',
        menuRefCodeHeader: '',
        menuName: '',
        menuPath: '',
        menuType: '',
        masApplicationName: '',
        userTypeGroup: '',
        orderNumber: '',
        create_date_start: '',
        create_date_end: '',
        last_date_start: '',
        last_date_end: ''
      },
      formAdd: {
        menuCode: '',
        menuRefCodeHeader: '',
        menuName: '',
        menuPath: '',
        menuType: 'Sub',
        masApplicationName: 'HRM',
        userTypeGroup: '',
        orderNumber: '',
        icon: ''
      },
      formUpdate: [],
      formUpdateItem: {
        menuCode: '',
        menuRefCodeHeader: '',
        menuName: '',
        menuPath: '',
        menuType: '',
        masApplicationName: '',
        userTypeGroup: '',
        orderNumber: '',
        icon: ''
      },
      nameRules: [
        (v) => !!v || 'Name is required',
        (v) => v.length <= 50 || 'Name must be less than 10 characters'
      ],
      // End Form Config ADD EDIT
      // Data Table Config
      columns: [
        { text: 'เรียงลำดับ', value: 'orderNumber' },
        { text: 'ภายใต้', value: 'menuRefCodeHeader' },
        { text: 'ประเภท', value: 'menuType' },
        { text: 'ชื่อ', value: 'menuName' },
        { text: 'Path', value: 'menuPath' },
        {
          text: 'จัดการกลุ่ม',
          value: 'action',
          sortable: false,
          align: 'center'
        }
      ],
      dataItem: [],
      // End Data Table Config

      // Config Import
      columnsImport: [
        { text: 'menuCode', value: 'menuCode' },
        { text: 'orderNumber', value: 'orderNumber' },
        { text: 'menuRefCodeHeader', value: 'menuRefCodeHeader' },
        { text: 'menuType', value: 'menuType' },
        { text: 'menuName', value: 'menuName' },
        { text: 'menuPath', value: 'menuPath' },
        { text: 'masApplicationName', value: 'masApplicationName' }
      ],
      columnsEmp: [
        { text: 'รหัสพนักงาน', value: 'empCode', align: 'center' },
        { text: 'ชื่อ-นามสกุล', value: 'empFull_NameTH' },
        { text: 'ประเภทพนักงาน', value: 'positionTypeName' },
        { text: 'ตำแหน่ง', value: 'positionName' },
        { text: 'แผนก', value: 'masDepartmentName' },
        { text: 'สาขา', value: 'masBranchName' },
        { text: 'บริษัท', value: 'masCompanyName' }
      ],
      dataItemImportChecKHide: true,
      dataItemImport: [],
      // End Config Import
      // Export Config
      exportType: 'xls',
      exportFileName: 'System-Menu.xls',
      exportWorksheet: 'WorkSheet',
      export_fields: {
        menuCode: 'menuCode',
        orderNumber: 'orderNumber',
        menuRefCodeHeader: 'menuRefCodeHeader',
        menuType: 'menuType',
        menuName: 'menuName',
        menuPath: 'menuPath',
        masApplicationName: 'masApplicationName'
      },
      json_meta: [
        [
          {
            key: 'charset',
            value: 'utf-8'
          }
        ]
      ],
      Application: [],
      UserTypeGroup: [],
      MenuHeader: [],
      menuType: ['Topic', 'Header', 'Sub'],
      selected: [],
      groupName: '',
      dataItemEmp: [],
      headers: [
        {
          text: 'กลุ่ม',
          align: 'start',
          sortable: false,
          value: 'name'
        },
        {
          text: 'ยอดรวมคน',
          align: 'start',
          sortable: false,
          value: 'total_uer_assign'
        },
        { text: 'รายชื่อพนักงาน', value: 'action', sortable: false, align: 'center' }

      ]
    }
  },
  async mounted () {
    await this.getGetToken(this.DNS_IP)
    this.dataReady = false
    await this.reload()
    // Get Data
  },
  methods: {
    async reload () {
      await this.getData()
      await this.getDataTypeGroup()
      await this.getDataMenuHeader()
      await this.getDataApplication()
    },
    async getData () {
      // Clear Data ทุกครั้ง
      this.dataItem = []

      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + this.path + "get",
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async (response) => {
          this.dataReady = true
          this.dataItem = response.data
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          console.log(error)
          this.dataReady = true
        })
    },
    async getDataById (item) {
      console.log(item)
      console.log(item.userTypeGroup)
      var userTypeGrop = []
      if (item.userTypeGroup) {
        item.userTypeGroup = JSON.parse(item.userTypeGroup)
        item.userTypeGroup.forEach((element) => {
          var s = {}
          s.name = element
          console.log(s)
          userTypeGrop.push(s)
        })
      }
      item.userTypeGroupConvert = userTypeGrop
      console.log('item userType GRoup ', item)
      this.formUpdate = item
      this.dialogEdit = true
    },
    async editData () {
      var userTypeGroup = this.formUpdate.userTypeGroupConvert
      var group = []
      userTypeGroup.forEach(element => {
        var s = {}
        s = element.name
        group.push(s)
      })
      console.log('group => ', JSON.stringify(group))
      this.formUpdate.userTypeGroup = JSON.stringify(group)

      console.log('this.formUpdate', this.formUpdate)
      // this.editDataGlobal(this.DNS_IP, this.path, this.PK, this.formUpdateItem)
      // this.dataReady = false
      this.$swal({
        title: 'ต้องการ แก้ไขข้อมูล ใช่หรือไม่?',
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#b3b1ab',
        confirmButtonText: 'ใช่',
        cancelButtonText: 'ไม่'
      })
        .then(async (result) => {
          this.dialogEdit = false
          let dt = {
            userTypeGroup: this.formUpdate.userTypeGroup,
            LAST_USER: this.$session.getAll().data.userName
          }
          console.log('dt', dt)
          await axios
            .post(
              // eslint-disable-next-line quotes
              this.DNS_IP + this.path + "edit/" + this.formUpdate.menuId,
              dt,
              {
                headers: {
                  'Application-Key': this.$session.getAll().ApplicationKey
                }
              }
            )
            .then(async (response) => {
              // Load Data
              await this.reload()
            })
            // eslint-disable-next-line handle-callback-err
            .catch((error) => {
              this.dataReady = true
              console.log('error function editDataGlobal : ', error)
            })
        })
        .catch((error) => {
          this.dataReady = true
          console.log('error function editDataGlobal : ', error)
        })
    },
    async getDataApplication () {
      // Clear Data ทุกครั้ง
      this.Application = []
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + "/master_application/" + "get",
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async (response) => {
          let rs = response.data
          for (var i = 0; i < rs.length; i++) {
            var d = rs[i]
            var s = {}
            s.value = d.masApplicationName
            s.text = d.masApplicationName
            d = s
            // console.log(d)
            this.Application.push(d)
          }
          // console.log('getDataApplication : ', this.Application)
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          console.log(error)
        })
    },
    async getDataTypeGroup () {
      // Clear Data ทุกครั้ง
      this.UserTypeGroup = []
      // console.log('getDataTypeGroup')
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + "/system_user_type_group/" + "get",
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async (response) => {
          let rs = response.data
          for (var i = 0; i < rs.length; i++) {
            var d = rs[i]
            var s = {}
            // s.value = d.userTypeGroupName
            // s.text = d.userTypeGroupName
            s.name = d.userTypeGroupName
            s.total_uer_assign = d.total_uer_assign
            // d = s
            // d.name = d.userTypeGroupName
            // console.log(d)
            this.UserTypeGroup.push(s)
          }
          // console.log('getDataTypeGroup : ', this.UserTypeGroup)
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          console.log(error)
        })
    },
    async getDataMenuHeader () {
      // Clear Data ทุกครั้ง
      this.MenuHeader = []
      // console.log('getDataTypeGroup')
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + "/system_menu/" + "get?not_in_menuType=Sub",
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async (response) => {
          let rs = response.data
          for (var i = 0; i < rs.length; i++) {
            var d = rs[i]
            var s = {}
            s.value = d.menuName
            s.text = d.menuName
            d = s
            // console.log(d)
            this.MenuHeader.push(d)
          }
          // console.log('getDataMenuHeader : ', this.MenuHeader)
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          console.log(error)
        })
    },
    async getDataEmployee (item) {
      this.groupName = item.name
      console.log(item)
      this.dataItemEmp = []
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + "/system_user/get?userTypeGroup=" + item.name,
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async (response) => {
          this.dataReady = true
          this.dataItemEmp = response.data
          console.log(this.dataItemEmp)
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          this.dataReady = true
        })
    }
  }
}
</script>
<style scope>
.v-data-table-header {
  background-color: #1b437c !important;
}
</style>



// WEBPACK FOOTER //
// src/components/HRM/System/Menu.vue